import { computed } from 'vue';

import { getLanguageByCode } from '@/static/languages';
import { useAudioStore } from '@/stores/audio';
import { useSocketStore } from '@/stores/socket';
import { useUserStore } from '@/stores/user';
import { LanguageCode } from '@/types/common';
import { Language } from '@/types/common';

export const useLanguage = () => {
  const audioStore = useAudioStore();
  const socketStore = useSocketStore();
  const userStore = useUserStore();

  const languageSavedScreen = computed<Language | null>(() => {
    const settingsCachedScreen = localStorage.getItem('settings_screen');
    if (!settingsCachedScreen) return null;
    const languageCodeSaved = JSON.parse(settingsCachedScreen).languageCode;
    return getLanguageByCode(languageCodeSaved);
  });

  const languageSavedSubtitle = computed<Language | null>(() => {
    const settingsCachedSubtitle = localStorage.getItem('settings_subtitle');
    if (!settingsCachedSubtitle) return null;
    const languageCodeSaved = JSON.parse(settingsCachedSubtitle).languageCode;
    return getLanguageByCode(languageCodeSaved);
  });

  const changeLanguage = (languageCode: LanguageCode) => {
    userStore.setPageLanguage(languageCode);
    audioStore.selectLanguage(languageCode as LanguageCode);
    socketStore.sendMessageChangeLanguage(languageCode as LanguageCode);
  };

  return { languageSavedScreen, languageSavedSubtitle, changeLanguage };
};
